import { apiClient } from '@app/lib'
import type { SugarContent } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useContent = (initialData?: SugarContent | null) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['content'],
    initialData,
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarContent>(`/api/content`, { signal })

      return data
    }
  })
}
